module.exports = __webpack_public_path__ + "img/zanwu.76fa0e80.png";